import styled, { css } from 'styled-components';

export const EnquiryFormColumn = styled.div`
  display: inline-flex;
  width: 100%;
  flex-direction: column;
`;

export const EnquiryFormContainer = styled.div<{ col: boolean }>`
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${({ col }) =>
    col
      ? css`
          flex-direction: column;

          ${EnquiryFormColumn}:not(:last-child) {
            margin-bottom: 20px;
          }
        `
      : css`
          ${EnquiryFormColumn} {
            @media screen and (min-width: 650px) {
              width: 45%;
            }
          }
          @media screen and (max-width: 649px) {
            flex-direction: column;
          }
        `};
`;

export const EnquiryFormInput = styled.div<{ mt?: number }>`
  margin-top: ${({ mt }) => mt || 10}px;
`;

export const EnquiryFormButtonContainer = styled.div`
  max-width: 380px;
  margin: 40px auto;
`;
